import React from 'react';

/**
 * Custom Recharts ReferenceLine label that stays fully inside the plot area.
 * Built-in positions ('right', 'insideTopRight') often get clipped by the SVG/container.
 */
export function createAverageLabel({
  text,
  fill = '#999999',
  fontSize = 11,
}) {
  function AverageLabel(props) {
    const { viewBox } = props;
    if (!viewBox || text == null || text === '') return null;

    const x = viewBox.x ?? 0;
    const y = viewBox.y ?? 0;
    const width = viewBox.width ?? 0;

    // Prefer above the line near the left of the plot; flip below if near the top edge
    const aboveY = y - 8;
    const labelY = aboveY < 16 ? y + 14 : aboveY;
    const labelX = x + Math.min(12, Math.max(4, width * 0.02));

    return (
      <g>
        {/* Soft backdrop so text stays readable over chart lines */}
        <rect
          x={labelX - 4}
          y={labelY - fontSize}
          width={Math.min(120, Math.max(70, String(text).length * 7))}
          height={fontSize + 6}
          rx={3}
          fill="#ffffff"
          fillOpacity={0.85}
        />
        <text
          x={labelX}
          y={labelY}
          fill={fill}
          fontSize={fontSize}
          fontWeight={600}
          textAnchor="start"
          dominantBaseline="auto"
        >
          {text}
        </text>
      </g>
    );
  }

  AverageLabel.displayName = 'AverageLabel';
  return AverageLabel;
}
